export default "__VITE_ASSET__5uYkCV8z__"